import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/use-auth';
import bdseLogoUrl from '../assets/bdse-logo.jpg';

/**
 * Unauthorized landing page. Mounted by RequireRole guard when the user is
 * authenticated and provisioned but doesn't have sufficient role for the
 * requested route.
 *
 * Distinct from ProfileNotProvisioned (no profile at all) and from Login
 * (no session). This means: you are who you say you are, you have access
 * to the platform, but not to this specific page.
 */
export function Unauthorized() {
  const { signOut } = useAuth();
  const navigate = useNavigate();

  async function handleSignOut() {
    await signOut();
    navigate('/login', { replace: true });
  }

  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <div className="bdse-glass-card w-[460px] max-w-[92vw] px-10 pt-8 pb-7 text-center">
        <div className="-mt-1 -mb-2">
          <img
            src={bdseLogoUrl}
            alt="BD Signal Engine"
            className="mx-auto w-60 h-auto"
            style={{ mixBlendMode: 'multiply' }}
          />
        </div>

        <p className="bdse-tagline mb-4">Access not permitted</p>

        <p className="text-sm text-bdse-text-secondary leading-relaxed mb-5">
          Your account doesn&apos;t have permission to view this page. If you
          believe this is a mistake, please contact your platform administrator.
        </p>

        <div className="flex flex-col gap-2">
          <Link to="/" className="bdse-btn-primary w-full">
            Return to dashboard
          </Link>
          <button type="button" onClick={handleSignOut} className="bdse-btn-ghost">
            Sign out
          </button>
        </div>

        <div className="mt-4 pt-3.5 border-t border-black/[0.06]">
          <p className="bdse-footnote">Ankura BD Intelligence Platform</p>
        </div>
      </div>
    </div>
  );
}
